var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip"},[_c('el-tooltip',{attrs:{"value":true,"manual":true,"effect":"light","content":_vm.content,"placement":"left"}},[_c('img',{attrs:{"src":require("../../assets/img/concact/location.png"),"alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }